import React, { useEffect, useState } from "react"
import { withRouter, Link } from "react-router-dom"

import MetaTags from "react-meta-tags"

import { Container } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import { getData, options } from "./data"
import { Filters } from "./Filters"
import Table from "./Table"
import axios from "axios"
import {API_URL, sitename} from "constants/constants"
import {FiltersCard} from "../../../components/Common/FiltersCard";
import moment from "moment";
const BoardReport = props => {
  const [data, setData] = useState([])
  const [month, setMonth] = useState(moment().format("YYYY-MM"))
  const [item, setItem] = useState('All')

  useEffect(() => {
    call()
  }, [])

  const options = [
    { label: "All", value: "All" },
    { label: "Sports", value: "Sports" },
    { label: "Pragmatic Games", value: "PragmaticGames" },
    { label: "Turbo Games", value: "TurboGames" },
    { label: "Spribe Games", value: "SpribeGames" },
    { label: "BigWins", value: "BigWins" },
  ]
  const [loadingMessage, setLoadingMessage] = useState("1");
  const call = () => {
    setLoadingMessage("1");
    axios({
      method: "get",
      url: `${API_URL}/admin/reports/board-reports?month=${month}&type=${item}`,
    })
      .then(function (response) {

        setData(response?.data?.data)
        setLoadingMessage("0");
        //  dispatch(getAllSuppliers())
        //  showMessage("success", response.data.message)
      })
      .catch(function (response) {
        //handle error
        //  showErrorMessages(response)
      })
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Admin" breadcrumbItem="Board Report" />
        </Container>
        <Filters
            setMonth={d => setMonth(d)}
            month={month}
            call={() => {
              call()
            }}
            item={item}
            setItem={setItem}
            options={options}
        />

        <Table
            data={data}
            loadingMessage={loadingMessage}
            setLoadingMessage={setLoadingMessage}
        />
      </div>
    </React.Fragment>
  )
}

export default withRouter(BoardReport)
